import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    title: _ctx.hint,
    class: _normalizeClass(["config-button", _ctx.modifiers])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type)))
  ], 10, _hoisted_1))
}